import { useEffect, useState } from 'react';
import type { ApolloError } from 'apollo-client';

import { fg } from '@confluence/feature-gating';

export const useOnboardingCTANudge = ({ actionSubjectId }: { actionSubjectId: string }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [errors] = useState<(ApolloError | Error)[]>([]);

	const CTANudgeConditions = !!actionSubjectId;

	// ------ Experiments ----------
	const experimentEligible = CTANudgeConditions && fg('cc_onboarding_experience');

	const setHidden = () => {
		setIsVisible(false);
	};

	useEffect(() => {
		if (experimentEligible) {
			setIsVisible(true);
		}
	}, [experimentEligible]);

	const onShow = () => {};

	const onboardingProps = {
		setHidden,
		onShow,
		onboardingErrors: errors,
	};

	return { isVisible, onboardingProps };
};
